export default __webpack_public_path__ + "dabc6975e323eaf6e01995e8c28500d3.gif";